
import QrcodeVue from "qrcode.vue";

export default {
  props: {
    value: {
      type: String,
      required: true,
      default: ""
    },
    size: {
      type: Number,
      default: 200
    },
    renderAs: {
      type: String,
      default: "svg"
    }
  },
  components: {
    QrcodeVue
  }
};
